const ANALYSIS_POLLING_TIMEOUT_MS = 150_000;

export default ANALYSIS_POLLING_TIMEOUT_MS;
